import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Traid from "./pages/Traid";
import Ailights from "./pages/Ailights";
import NotFound from "./pages/NotFound";
import Navbar from "./base-components/Navbar";
import Footer from "./base-components/Footer";
import ScrollManager from "./base-components/ScrollManager";
import TwoSequel from "./pages/TwoSequel";
import ThanksPage from "./pages/ThanksPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
// import Report from "./pages/Report";

function App() {
  return (
    <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/traid" element={<Traid />} />
        <Route path="/ailights" element={<Ailights />} />
        <Route path="/two-sequel" element={<TwoSequel />} />
        {/*<Route path="/report" element={<Report />} />*/}
        <Route path="/thanks" element={<ThanksPage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
